<ng-template #desktopSecondaryMenuTemplate>
	<div class="w-desktop-secondary-menu" [libFlexRow]="true" [libFlexRowGap]="'24px'">
		@for (menuItem of secondaryMenuItems(); track menuItem.id; let first = $first; let last = $last) {
		<a [routerLink]="menuItem.routerLink" libFlexColumn class="item" [class.active]="menuItem.isActive">
			<div class="icon">
				<lib-icon [type]="menuItem.iconType" [size]="'small'"></lib-icon>
			</div>
			<div>
				{{ menuItem.title }}
			</div>
		</a>
		}
	</div>
</ng-template>

<ng-template #mobileMenuSelectorTemplate>
	@if (menuItems(); as menuItems) {

	<lib-tooltip-menu #menuSelectorItems>
		@if (menuItems?.length) {
		<div [style.width]="widthOfMenuItemSelectorTrigger() + 'px'">
			<div class="pad">
				<div [libFlexRow]="true" [libFlexRowGap]="'8px'">
					@for (menuItem of menuItems; track menuItem.id; let first = $first; let last = $last) {
					<div libFlexColumn [style.width]="calculateFlexWidth(menuItemSelectorWrapSize(), 8)">
						<lib-tooltip-menu-item
							[isFirst]="first"
							[isLast]="last"
							[removePadding]="true"
							[typeIcon]="menuItem.iconType"
							[routerLink]="menuItem.routerLink"
							[title]="menuItem.title"
						></lib-tooltip-menu-item>
					</div>
					}
				</div>
			</div>
		</div>
		}
	</lib-tooltip-menu>

	<div libFlexRow [libFlexRowGap]="'8px'" [libFlexRowAlign]="'center'">
		<div libFlexColumn libFlexFill #menuItemSelectorTrigger>
			<div
				libFlexRow
				[libFlexRowAlign]="'center'"
				[libFlexRowGap]="'16px'"
				[libTooltipMenuMaxWidth]="widthOfMenuItemSelectorTrigger()"
				[libTooltipMenu]="menuSelectorItems"
				[libTooltipMenuPlacement]="'bottom-start'"
				[libTooltipMenuTrigger]="'click'"
				class="ui-cursor-pointer w-menu-selector"
			>
				<dib libFlexColumn libFlexFill>
					@for (menuItem of menuItems; track menuItem.id) {
					<ng-container>
						@if ((menuItem.isActive)) {
						<div>{{ menuItem.title }}</div>
						}
					</ng-container>
					}
				</dib>
				<div libFlexColumn>
					<lib-icon [type]="'chevronDown'" [size]="'default'"></lib-icon>
				</div>
			</div>
		</div>
	</div>

	}
</ng-template>

<!-- Trial expired -->
<ng-template #trialExpiredTemplate>
	@if(isTrialExpired()) {
	<div class="pad-bottom pad-top">
		<lib-message [title]="'Trial expired'" [type]="'warning'" [hideIcon]="true">
			<div>
				You may still continue using our app, but you can no longer create new clients. Please consider
				supporting us by subscribing.
			</div>
			<div class="push-top-sm">
				If you have any questions, feel free to reach out to us using the helpdesk chat.
			</div>
			<div class="push-top-sm">
				<lib-button
					[buttonType]="'primary'"
					[icon]="'purchase'"
					[routerLink]="dependencies.navigateService.subscribePage().getUrl()"
				>
					Subscribe
				</lib-button>
			</div>
		</lib-message>
	</div>
	}
</ng-template>

<!-- Content -->
<ng-template #contentTemplate>
	<ng-content></ng-content>
</ng-template>

<!-- Card template -->
<ng-template #cardTemplate>
	@if (pageCard(); as pageCard) {

	<lib-layout-card
		[imagePriority]="true"
		[title]="pageCard.title.value"
		[subtitle]="pageCard.subtitle ?? ''"
		[updated]="formattedUpdatedTime()"
		[avatar]="pageCard.avatar?.avatar"
		[tags]="pageTags()"
		[avatarName]="pageCard.avatar?.avatarName ?? pageCard.title.value"
		[cardDesign]="'default'"
		[buttonsMode]="isMobileOrTabletView() ? 'single' : 'extendedList'"
		[buttonsExtendedListThreshold]="1"
		[showNgContent]="pageCard.nutrition ? true : false"
		[buttons]="isMobileView() ? [] : calculatedMetadataCardButtons()"
		[isEditableAvatar]="pageCard.avatar?.upload ? true : false"
		[isEditableTitle]="pageCard.title.save ? true : false"
		(editAvatarClick)="handleEditAvatar()"
		(titleUpdated)="handleEditTitle($event)"
	>
		<div libFlexRow [libFlexRowAlign]="'start'" [libFlexRowGap]="'16px'">
			<!-- Card details -->
			<div libFlexColumn libFlexFill>
				@if (pageCard.nutrition) {
				<div [libFlexRow]="isMobileOrTabletView()" [libFlexRowGap]="'16px'">
					<div libFlexColumn>
						<lib-nutrition-boxes
							[nutritionRowAlign]="'start'"
							[design]="'tagsAlt'"
							[proteins]="pageCard.nutrition.proteins"
							[carbs]="pageCard.nutrition.carbs"
							[fats]="pageCard.nutrition.fats"
							[kcal]="pageCard.nutrition.kcal"
						></lib-nutrition-boxes>
					</div>

					@if (nutritionGraphConfig(); as nutritionGraphConfig) { @if(!isMobileOrTabletView()) {
					<div libFlexColumn>
						<lib-pie-chart
							[view]="[40, 40]"
							[showLabels]="false"
							[singleSeries]="nutritionGraphConfig.singleSeries"
							[colorScheme]="nutritionGraphConfig.colorScheme"
						></lib-pie-chart>
					</div>
					} }
				</div>
				}
			</div>
		</div>
	</lib-layout-card>
	}
</ng-template>

@if (layoutType(); as layoutType) {

<!-- Mobile version -->
@if (layoutType === 'mobile') {

<div class="w-mobile-content">
	<div class="w-content">
		<!-- Trial expired -->
		<ng-template [ngTemplateOutlet]="trialExpiredTemplate"></ng-template>

		@if (showMenuSelector()) {
		<div class="pad-top">
			<ng-template
				[ngTemplateOutlet]="mobileMenuSelectorTemplate"
				[ngTemplateOutletContext]="{ isStandalone: false, isMobile: true }"
			></ng-template>
		</div>
		}

		<!-- Card -->
		@if (showCardOnMobile()) {
		<div class="pad-top">
			<ng-template [ngTemplateOutlet]="cardTemplate"></ng-template>
		</div>
		}

		<!-- Content -->
		<div class="pad-top">
			<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
		</div>
	</div>
</div>
}

<!-- Desktop version -->
@if (layoutType === 'desktop') {

<div [ngStyle]="layoutSizeStyles()">
	<div>
		<div class="w-desktop-content">
			<!-- Trial expired -->
			<ng-template [ngTemplateOutlet]="trialExpiredTemplate"></ng-template>

			<!-- Card-->
			@if (showCardOnDesktop()) {
			<div class="pad-top">
				<ng-template [ngTemplateOutlet]="cardTemplate"></ng-template>
			</div>
			}

			<!-- Secondary menu -->
			@if (showSecondaryMenu()) {
			<div class="pad-top">
				<ng-template [ngTemplateOutlet]="desktopSecondaryMenuTemplate"></ng-template>
			</div>
			}

			<!-- Content -->
			<div class="pad-top">
				<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
			</div>
		</div>
	</div>
</div>

} }
